import Vue from 'vue'
import axios from 'axios'

/**
 * 提示函数
 */
const v = new Vue()
const tip = msg => {
  v.$message.warning(msg)
}

let token = null
const useToken = type => {
  // 移除缓存使用
  // tokenName = type
  token = sessionStorage.getItem(type)
  if (!token) token = sessionStorage.getItem('generalToken')
}
/**
 * 跳转登录页
 * */

const instance = axios.create({ timeout: 1000 * 80 })
const instance1 = axios.create({ timeout: 1000 * 80 })
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  config => {
    config.headers.token = token
    // showFullScreenLoading()
    return config
  },
  error => Promise.error(error))

// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  response => {
    if (
      response.data === null &&
      response.config.responseType === 'json' &&
      response.request.responseText !== null
    ) {
      try {
        response.data = JSON.parse(response.request.responseText)
      } catch (e) {
        //
      }
    }
    return response.data
  },
  // 请求失败
  error => {
    const { response } = error
    if (response) {
      return Promise.reject(response)
    } else {
      tip('请求资源不存在！')
      return Promise.reject(error)
    }
  })

// instance1没有loading加载的接口
instance1.interceptors.request.use(
  config => {
    config.headers.token = token
    return config
  },
  error => Promise.error(error))

// 响应拦截器
instance1.interceptors.response.use(
  // 请求成功
  response => {
    if (
      response.data === null &&
      response.config.responseType === 'json' &&
      response.request.responseText !== null
    ) {
      try {
        response.data = JSON.parse(response.request.responseText)
      } catch (e) {
        //
      }
    }
    return response.data
  },
  // 请求失败
  error => {
    const { response } = error
    if (response) {
      return Promise.reject(response)
    } else {
      tip('请求资源不存在！')
      return Promise.reject(error)
    }
  })

export async function request(method, url, data, type = 'userToken', isLoading = false) { // 暴露 request 给我们好API 管理
  await useToken(type)
  method = method.toLocaleLowerCase()
  const instanceToUse = isLoading ? instance : instance1
  let response
  if (method === 'post') {
    response = await instanceToUse.post(url, data)
  } else if (method === 'get') {
    const params = {
      timestamp: Date.now(),
      ...data
    }
    response = await instanceToUse.get(url, { params })
  }
  return response // 处理响应并返回
}
